import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { Button, Col, Nav, Row, Tab } from 'react-bootstrap';
import { PayrollProcessContext } from '../../RemunerationProcesses/context/PayrollProcessProvider';
import { useSetTab } from '../../../services/hooks';
import { showReliquidationProcessRequest } from '../../../requests/reliquidationProcesses';
import { Icon } from '../../../components';
import ReliquidationProcessSummary from './ReliquidationProcessSummary';
import ReliquidationProcessBalances from './ReliquidationBalances/ReliquidationProcessBalances';

const ReliquidationProcessShow = props => {
  const { location, match } = props;
  const { id } = match.params;
  const { setReliquidationProcess, reliquidationProcess } = useContext(PayrollProcessContext);
  const [moreData, setMoreData] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const setTab = () => {
    return 'summary';
  };
  const { onlyShow } = location.state ?? {};
  const vOnlyShow = onlyShow || false;

  const [key, setKey] = useSetTab(setTab, location);
  const handleReliquidationProcess = () => {
    showReliquidationProcessRequest(id, {
      dispatch,
      service: 'payroll',
      successCallback: response => {
        setReliquidationProcess(response.data);
      }
    });
  };
  const reliquidationProcessName = reliquidationProcess ? reliquidationProcess.name : '';

  useEffect(handleReliquidationProcess, [moreData]);
  return (
    <>
      <Row className="mt-4">
        <Col
          md={1}
          xs={2}
          style={{
            maxWidth: '3rem'
          }}
        >
          <Col className="pl-1 pr-1">
            <Button
              variant="circle-dark"
              className="btn-circle mt-3"
              block
              onClick={() => {
                history.push(`/reliquidation_processes`);
              }}
            >
              <Icon icon="chevron-back" />
            </Button>
          </Col>
        </Col>
        <Col md={11} xs={10}>
          <Col xs={12}>
            <h2 className="mb-2 mt-2">Procesos de Reliquidación {reliquidationProcessName}</h2>
          </Col>
        </Col>
      </Row>
      <Tab.Container
        id="remunerations-processes-index.tabs"
        activeKey={key}
        onSelect={k => setKey(k)}
        mountOnEnter
        unmountOnExit
      >
        <Nav variant="pills">
          <Nav.Item>
            <Nav.Link className="mb-1" eventKey="summary">
              <Icon icon="location" />
              Resumen
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link className="mb-1" eventKey="assets-discounts">
              <Icon icon="location" />
              Haberes y Desctos
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="summary">
            <ReliquidationProcessSummary
              reliquidationProcess={reliquidationProcess}
              setMoreData={setMoreData}
              moreData={moreData}
              onlyShow={vOnlyShow}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="assets-discounts">
            <ReliquidationProcessBalances onlyShow={vOnlyShow} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default ReliquidationProcessShow;
